import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en_US from '../../translations/en_US.json';
import uk_UA from '../../translations/uk_UA.json';
import ru_RU from '../../translations/ru_RU.json';
import { LOCALES } from '../../constants/locales';

i18n.use(initReactI18next).init({
  fallbackLng: LOCALES.EN,
  lng: LOCALES.EN,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    [LOCALES.EN]: en_US,
    [LOCALES.UA]: uk_UA,
    [LOCALES.RU]: ru_RU,
  },
  ns: ['translations'],
  defaultNS: 'translations',
  react: {
    bindI18n: 'languageChanged loaded',
    nsMode: 'default',
    useSuspense: false,
  },
});

export default i18n;
